import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Keyboard, A11y } from 'swiper';
import TiledLink from './TiledLink';
import ButtonLink from '../shared/ButtonLinkComponent';
import { withWidgetSpacingWrapper } from '../shared/WidgetSpacingWrapper';
import WidgetIdWrapper from '../shared/WidgetIdWrapper';
import { device } from '../../utils/styled-component-mixins';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/bundle';

const TiledLinkSectionWrapper = styled.div`
  .container-padding-md {
    ${(props) =>
      props.backgroundImage && props.isCarousel
        ? `background-image: url('${props.backgroundImage}');`
        : `background-color: var(--grey);`}
    ${(props) =>
      props.isCarousel &&
      `padding-left: 0;
        padding-right: 0;`}
    position: relative;

    &:before {
      background-color: var(--white);
      ${(props) =>
        props.isCarousel
          ? `clip-path: polygon(280% 0, 0 35%, 0 -1%);`
          : `clip-path: polygon(100% 0, 0 10%, 0 -1%);`}
      content: '';
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      width: 100%;
    }

    &:after {
      background-color: var(--white);
      ${(props) =>
        props.isCarousel
          ? `clip-path: polygon(0 80%, 100% 65%, 100% 100%, 0% 101%);`
          : `clip-path: polygon(0 96%, 100% 90%, 100% 100%, 0% 101%);`}
      content: '';
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      width: 100%;
    }

    @media ${device.desktop} {
      ${(props) => props.backgroundImage && `background-image: url('${props.backgroundImage}');`}
      background-position: center;
      background-size: cover;
      display: block;
      ${(props) =>
        props.isCarousel &&
        `padding-left: 0;
        padding-right: 0;`}
      z-index: 0;

      &:after {
        ${(props) =>
          props.isCarousel
            ? `clip-path: polygon(0 96%, 100% 55%, 100% 100%, 0% 101%);`
            : `clip-path: polygon(0 96%, 100% 70%, 100% 100%, 0% 101%);`}
        z-index: -1;
      }

      &:before {
        clip-path: polygon(100% 0, 0 30%, 0 -1%);
        ${(props) =>
          props.isCarousel
            ? `clip-path: polygon(100% 0, 0 45%, 0 -1%);`
            : `clip-path: polygon(100% 0, 0 30%, 0 -1%);`}
        z-index: -1;
      }

      & > div {
        position: relative;

        .btn-wrapper {
          bottom: 2.5rem;
          position: absolute;
          right: 11rem;
        }
      }
    }
  }

  .heading-wrapper {
    margin-bottom: 4rem;

    h2 {
      font-size: 3rem;
      font-weight: normal;
      line-height: 3.2rem;
      padding: 0 1.5rem;
      position: relative;
      text-align: center;
      z-index: 1;

      @media ${device.desktop} {
        font-size: 3.6rem;
        line-height: 4.8rem;
      }
    }

    .sub-heading {
      margin: 1.6rem auto 0 auto;
      max-width: 70rem;
      padding: 0 1.5rem;
      position: relative;
      text-align: center;
      z-index: 1;

      @media ${device.desktop} {
        font-size: 2rem;
        line-height: 3.2rem;
      }
    }
  }

  .tiled-link-section {
    display: flex;
    filter: drop-shadow(0px 16px 80px rgba(91, 110, 127, 0.25));
    flex-direction: column;
    margin-bottom: 2.5rem;
    position: relative;
    z-index: 100;

    @media ${device.desktop} {
      display: grid;
      grid-auto-rows: 1fr;
      grid-template-columns: 50% 50%;
      grid-column-gap: 1.6rem;
      grid-row-gap: 1.6rem;
      margin-bottom: 0;
      margin-right: 50%;
    }
  }

  .btn-wrapper {
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 100;

    @media ${device.desktop} {
      display: block;
    }
  }

  .swiper-pagination {
    max-width: 36rem;
    left: 50%;
    transform: translateX(-50%);
  }

  .swiper {
    &:hover {
      .swiper-button-next:not(.swiper-button-disabled),
      .swiper-button-prev:not(.swiper-button-disabled) {
        opacity: 1;
      }

      .swiper-button-disabled {
        opacity: 0.35;
      }
    }

    .swiper-slide {
      height: auto;

      @media ${device.desktop} {
        max-width: 23%;
      }
    }
    article {
      box-shadow: var(--card-shadow);
      height: 100%;

      a {
        height: 100%;
        justify-content: space-between;

        @media ${device.desktop} {
          min-height: 36rem;
        }
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      display: none;

      @media ${device.desktop} {
        background-color: var(--grey);
        border-radius: 50%;
        display: block;
        height: 5.3rem;
        width: 5.3rem;
        opacity: 0;
        transition: all 0.3s linear;
      }

      &:after {
        color: var(--charcoal-2);
        font-size: 2.5rem;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .swiper-button-prev {
      left: 0.55rem;
    }

    .swiper-button-next {
      right: 0.55rem;
    }
  }
`;

const TiledLinkSection = (props) => (
  <WidgetIdWrapper widgetID={props.properties.widgetID}>
    <TiledLinkSectionWrapper
      className="card-slider"
      backgroundImage={props.properties.backgroundImage}
      isCarousel={props.tiles.length > 4}
    >
      <div className="heading-wrapper">
        <h2>{props.properties.heading}</h2>
        {props.properties.subHeading && (
          <p className="sub-heading">{props.properties.subHeading}</p>
        )}
      </div>
      <div className="container-padding-md">
        <div>
          {props.tiles.length > 4 ? (
            <Swiper
              pagination={{ clickable: false }}
              slidesPerView="auto"
              centeredSlides={true}
              spaceBetween={16}
              modules={[Pagination, Navigation, Keyboard, A11y]}
              a11y={true}
              navigation={true}
              keyboard={true}
              breakpoints={{
                992: {
                  centeredSlides: false,
                  slidesPerView: 'auto',
                  slidesPerGroupSkip: 1
                }
              }}
            >
              {props.tiles.map((link) => (
                <SwiperSlide key={link.nodeID}>
                  <TiledLink {...props.properties} {...link} />
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className="tiled-link-section">
              {props.tiles.map((link) => (
                <TiledLink key={`${link.nodeID}`} {...props.properties} {...link} />
              ))}
            </div>
          )}
          {props.properties.ctaText && props.properties.ctaUrl && (
            <ButtonLink
              text={props.properties.ctaText}
              link={props.properties.ctaUrl}
              target="_self"
              type="tertiary"
              theme="light"
            />
          )}
        </div>
      </div>
    </TiledLinkSectionWrapper>
  </WidgetIdWrapper>
);

export default withWidgetSpacingWrapper(TiledLinkSection);
